export const environment = {
  production: true,
  envName: 'qa',
  hostUrl: 'http://private-00d059-bokbok1.apiary-mock.com/api/web/',
  apiaryGestionSinopticoUrl: 'https://private-b2ac5c-consinoptico.apiary-mock.com/api-jor/',
  apiaryGestionJornadaUrl: 'https://private-aeb42c-congestionjornada.apiary-mock.com/api/',
  apiaryUrl: 'https://private-b2ac5c-consinoptico.apiary-mock.com/api-jor/',
  hostSinopticoUrl: 'https://conecta.qa.cursor.cl/api-jor/',
  hostDespachadorUrl: 'https://conecta.qa.cursor.cl/api-jor/',
  apiaryDespachadorUrl: 'https://conecta.qa.cursor.cl/api-jor/',
  apiaryGestionBusesUrl: 'https://conecta.qa.cursor.cl/api-jor/',
  apiaryGestionConductoresUrl: 'https://conecta.qa.cursor.cl/api-jor/',
  keyCloakRedirectUri: 'https://conecta.qa.cursor.cl/web-admin/admin/despachador',
  keyCloakBearerInterceptor: true,
  umbrales: {
    conductorProxTerminar: 30,
    horaExtraSobreHoraPlanificada: 1
  },
  // Tiempo (ms) que el toast de error permanece visible antes de cerrarse automaticamente (5 min)
  toastErrorTimeout: 300000,
  // Tiempo (ms) que el toast de exito permanece visible antes de cerrarse automaticamente (1 min)
  toastSuccessTimeout: 60000,
  // Tiempo (ms) que el toast de advertencia permanece visible antes de cerrarse automaticamente (2 min)
  toastWarningTimeout: 120000
};
